import React, { useEffect, useState } from "react";
import {
  CogIcon,
  UserIcon,
  BuildingLibraryIcon,
} from "@heroicons/react/24/outline";
import DashboardHeader from "../Common/DashboardHeader";
import CustomerHeader from "../Common/CustomerHeader";
import Stepper from "../Common/Stepper";
import CustomerInput from "../reusableComponents/CustomerInput";
import { Link, useNavigate } from "react-router-dom";
import {
  addUpdateCustomerBankData,
  DetailsApi,
  getIfscData,
  validateGstinPan,
  verifyBankDetails,
} from "../../services/redux/ApiActions";
import { useDispatch, useSelector } from "react-redux";
import showNotification from "../../services/redux/NotifcationService";
import { setDetailsData } from "../../services/redux/DetailsReducer";
import LogoDiv from "../Common/LogoDiv";
import { setCustomerBankDetails } from "../../services/redux/CustomerBankDataReducer";
import SelectStatus from "../reusableComponents/SelectStatus";
import AccountTypeSelect from "../reusableComponents/AccountTypeSelect";
import logo from "../../img/BBPS_Horizontal.png";

export default function StepFive() {
  const customerData = useSelector(
    (state) => state?.customerData?.customerData,
  );
  const customerBankData = useSelector(
    (state) => state?.customerBankDetails?.customerBankDetails,
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState(customerBankData);
  const [ifscApidata, setIfscApiData] = useState();
  const [validationResponse, setValidationResponse] = useState();
  const [bankDetailsVerified, SetBankDetailsVerified] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [approveVal, setApproveVal] = useState(0);
  const details = useSelector((state) => state?.details?.details);
  const gstinResponse = JSON.parse(details?.result?.gstinResponse);
  const VerifyBankDetails = async (event) => {
    //console.log(data?.accountType);
    if (data?.accountName === "" || data?.accountName === undefined) {
      showNotification("Account name is required", "error");
    } else if (
      data?.accountNumber === "" ||
      data?.accountNumber === undefined
    ) {
      showNotification("Account number is required", "error");
    } else if (
      data?.confirmAccountNumber === "" ||
      data?.confirmAccountNumber === undefined
    ) {
      showNotification("Confirm account is required", "error");
    } else if (data?.accountType === undefined) {
      showNotification("Account type is required", "error");
    } else if (data?.confirmAccountNumber !== data?.accountNumber) {
      showNotification(
        "Account number and confirm account number should be same",
        "error",
      );
    } else if (data?.ifsc === "" || data?.ifsc === undefined) {
      showNotification("IFSC is required", "error");
    } else if (data?.branch === "" || data?.branch === undefined) {
      showNotification("Branch is required", "error");
    } else if (data?.bank === "" || data?.bank === undefined) {
      showNotification("Bank is required", "error");
    } else {
      let Data = {
        accountNumber: data?.accountNumber,
        ifsc: data?.ifsc,
        tradeName: gstinResponse?.TradeName,
        legalName: gstinResponse?.LegalName,
        customerId: customerData?.custId,
        MaxApiHitLimit: 20,
        gstin: details?.result?.gstin,
        accountName: data?.accountName,
      };
      //console.log(gstinResponse);
      const res = await dispatch(
        verifyBankDetails(Data, customerData?.token_chr),
      );
      if (res === null) {
        showNotification("Something went wrong", "error");
      }
      if (
        res?.responseCode === "KPY00" &&
        res?.accountVerificationStatus !== "Unverified"
      ) {
        showNotification("Account is Verified", "success");
        SetBankDetailsVerified(true);
        setIsVerified(true);
        let temp = { ...validationResponse };
        temp.message = "Benificiary Name : " + res.beneficiaryName;
        temp.status = " is verified";
        temp.color = "green";
        setApproveVal(1);
        setValidationResponse(temp);
      }
      if (
        res?.responseCode === "KPY00" &&
        res?.accountVerificationStatus === "Unverified"
      ) {
        if (res?.beneficiaryName !== data.legalName || data.tradeName) {
          showNotification(
            "Benificiary Name doesn't match with Vendor's trader name or legal name",
            "error",
          );
          SetBankDetailsVerified(true);
          let temp = { ...validationResponse };
          temp.message =
            "Benificiary Name doesn't match with vendor's trader name or legal name,please re-check the bank details you have entered.";
          temp.status = "";
          temp.color = "red";
          setApproveVal(0);
          setValidationResponse(temp);
        }
      }
      if (res?.responseCode !== "KPY00") {
        showNotification("Benificiary Account cannot be verified", "error");
        SetBankDetailsVerified(true);
        let temp = { ...validationResponse };
        temp.message = "Benificiary Account";
        temp.status =
          " cannot be verified please re-check the bank details you have entered";
        temp.color = "red";
        setApproveVal(0);
        setValidationResponse(temp);
      }
      setData((prevData) => ({
        ...prevData,
        beneficiaryName: res?.beneficiaryName,
      }));
      dispatch(setCustomerBankDetails(data));
    }
    // }
  };
  useEffect(() => {
    getDetails();
  }, []);

  const getDetails = async () => {
    const Payload = {
      id: customerData?.custId,
    };
    // console.log(Payload)
    const res = await dispatch(
      DetailsApi(Payload, customerData?.token_chr, "customer"),
    );
    setData((prevData) => ({
      ...prevData,
      programId: res?.result?.programId,
    }));
    if (res.result.customerBankDetails !== null) {
      const label = res?.result?.customerBankDetails?.accountType;
      //console.log("programId", res?.result?.programId);
      setData((prevData) => ({
        ...prevData,
        programId: res?.result?.programId,
        accountName: res?.result?.customerBankDetails?.accountName,
        bank: res?.result?.customerBankDetails?.bank,
        bankId: res?.result?.customerBankDetails?.id,
        accountNumber: res?.result?.customerBankDetails?.accountNumber,
        confirmAccountNumber: res?.result?.customerBankDetails?.accountNumber,
        ifsc: res?.result?.customerBankDetails?.ifsc,
        // accountType:res?.result?.customerBankDetails?.accountType!==null?res?.result?.customerBankDetails?.accountType==="Savings"?"1":"2":"1"
        accountType:
          label === "Savings"
            ? "1"
            : label === "Default" || label === "0"
              ? "0"
              : label === "Current"
                ? "2"
                : "1",
      }));
    } else {
      setData((prevData) => ({
        ...prevData,
        accountType: "0",
      }));
    }
  };

  useEffect(() => {
    if (data?.ifsc && data.ifsc.length === 11) {
      GetBankInfo(data.ifsc);
    }
  }, [data?.ifsc]); // Dependency array ensures this effect runs when `data.ifsc` changes

  useEffect(() => {
    getDetails();
  }, []); // Run only once on component mount

  // addUpdateCustomerBankData
  const handleSubmit = async () => {
    const payload = {
      customerId: customerData?.custId,
      // accountType: data?.accountType === "1" ? "Savings" : "Current",
      accountType:
        data?.accountType === "1"
          ? "Savings"
          : data?.accountType === "0"
            ? "Default"
            : "Current",
      accountName:
        data?.beneficiaryName === null || data?.beneficiaryName === undefined
          ? data?.accountName
          : data?.beneficiaryName,
      encAccountNumber: data.accountNumber,
      bankName: data.bank,
      ifsc: data.ifsc,
      bankId: data.bankId,
      isVerified: isVerified,
    };
    const res = await dispatch(
      addUpdateCustomerBankData(payload, customerData?.token_chr),
    );
    if (res.statusCode == 200) {
      showNotification("Account added or updated successfully", "success");
      // console.log(userAgent)
      getDetails();
      if (data?.programId === 32 || data?.programId === 33) {
        navigate("/Customer/Step6");
      } else if (data?.programId === 34) {
        navigate("/Customer/EmailServerDetail");
      } else {
        navigate("/Customer/Step7");
      }
    }
  };

  const GetBankInfo = async (val) => {
    let IFSCCode = data?.ifsc || val;
    if (
      IFSCCode === undefined ||
      IFSCCode === "" ||
      IFSCCode === "" ||
      IFSCCode.length !== 11
    ) {
      //  alertService.addWarning('Please Enter IFSC')
      showNotification("Please Enter IFSC", "error");
    } else {
      const res = await dispatch(
        getIfscData(IFSCCode, customerData?.token_chr),
      );
      if (res !== null) {
        showNotification("IFSC Code Valid", "success");
        setData((prevData) => ({
          ...prevData,
          bank: res?.result?.bank,
          branch: res?.result?.branch,
          bankId: res?.result?.id,
        }));
      }
    }
  };

  const accountTypeOptions = [
    { value: "0", label: "Default" }, // Placeholder
    { value: "1", label: "Savings" },
    { value: "2", label: "Current" },
  ];
  // const handleChange = (e) => {
  //     const { name, value } = e.target;
  //     setData((prevData) => ({
  //         ...prevData,
  //         [name]: value,
  //     }));
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let cleanedValue = value;

    switch (name) {
      case "accountName":
        // Allow only alphanumerics and space, max 50 chars
        cleanedValue = value.replace(/[^a-zA-Z0-9\s]/g, "").slice(0, 50);
        break;

      case "accountNumber":
      case "confirmAccountNumber":
        // Allow alphanumerics only, max 30 chars
        cleanedValue = value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 30);
        break;

      case "ifsc":
        // Allow alphanumerics only, max 11 chars, uppercase preferred
        cleanedValue = value
          .toUpperCase()
          .replace(/[^A-Z0-9]/g, "")
          .slice(0, 11);
        break;

      default:
        // No restriction for other fields
        cleanedValue = value;
        break;
    }

    setData((prevData) => ({
      ...prevData,
      [name]: cleanedValue,
    }));
  };

  const handleSelectChange = (e) => {
    const value = e.target.value;
    setData((prevData) => ({
      ...prevData,
      accountType: value,
    }));
    //console.log(data);
  };
  return (
    <>
      <body className="mailsentbody">
        <LogoDiv className="logoBG">
          <div className="rightElement">
            <CustomerHeader />
            <div className="grid mt-6 grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
              <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                <Stepper />
                <div className="bg-white mx-2 shadow-xl p-6 mt-4 rounded-lg">
                  <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                    <div className="col-span-12 md:col-span-8 lg:col-span-8">
                      <div className="py-2 text-center">
                        <h1 className="text-xl font-semibold letter-spacing">
                          Account Details
                        </h1>
                      </div>
                    </div>
                    <div className="col-span-12 md:col-span-2 lg:col-span-2">
                      {data?.programId === 32 || data?.programId === 33 ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "right",
                            marginTop: "-5px",
                          }}
                        >
                          <img src={logo} width={"100px"} height={"100px"} />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="py-2 text-center">
                    <h1 className="text-sm text-gray-600">
                      Please enter bank details of your organisation
                    </h1>
                  </div>
                  <div className="mt-2 border-none border-collapse rounded-md">
                    <div className="grid mt-6 grid-cols-12 gap-4">
                      <div className="col-span-12 ">
                        <label
                          for="accountName"
                          className="block text-md font-medium leading-6 text-gray-900"
                        >
                          Account Name <span className="text-red-600">*</span>
                        </label>
                        <CustomerInput
                          onChange={handleChange}
                          name="accountName"
                          placeHolder="ENTER ACCOUNT NAME"
                          inputStyles={{ padding: "12px" }}
                          value={data?.accountName || ""}
                        />
                      </div>
                      <div className="col-span-12 md:col-span-12 lg:col-span-6">
                        <label
                          for="accountNumber"
                          className="block text-md font-medium leading-6 text-gray-900"
                        >
                          Account Number<span className="text-red-600">*</span>
                        </label>
                        <CustomerInput
                          onChange={handleChange}
                          name="accountNumber"
                          placeHolder="ENTER ACCOUNT NUMBER"
                          inputStyles={{ padding: "12px" }}
                          value={data?.accountNumber || ""}
                        />
                      </div>
                      <div className="col-span-12 md:col-span-12 lg:col-span-6 ">
                        <label
                          for="confirmAccountNumber"
                          className="block text-md font-medium leading-6 text-gray-900"
                        >
                          Confirm Account Number
                          <span className="text-red-600">*</span>
                        </label>
                        <CustomerInput
                          type="password"
                          disableCopyPaste={true}
                          onChange={handleChange}
                          name="confirmAccountNumber"
                          placeHolder="ENTER CONFIRM ACCOUNT NUMBER"
                          inputStyles={{ padding: "12px" }}
                          value={data?.confirmAccountNumber || ""}
                        />
                      </div>
                      <div className="col-span-12 ">
                        <label
                          for="accountType"
                          className="block text-md font-medium leading-6 text-gray-900"
                        >
                          Account Type <span className="text-red-600">*</span>
                        </label>
                        <AccountTypeSelect
                          inputStyles={{ padding: "12px" }}
                          value={data?.accountType}
                          onChange={handleSelectChange}
                          options={accountTypeOptions}
                        />
                      </div>
                      <div className="col-span-12 ">
                        <label
                          for="ifsc"
                          className="block text-md font-medium leading-6 text-gray-900"
                        >
                          IFSC <span className="text-red-600">*</span>
                        </label>
                        <CustomerInput
                          onChange={handleChange}
                          // onBlur={GetBankInfo}
                          name="ifsc"
                          placeHolder="ENTER IFSC"
                          inputStyles={{ padding: "12px" }}
                          value={data?.ifsc || ""}
                        />
                      </div>
                      <div className="col-span-12 md:col-span-6 lg:col-span-6">
                        <label
                          for="branch"
                          className="block text-md font-medium leading-6 text-gray-900"
                        >
                          Branch <span className="text-red-600">*</span>
                        </label>
                        <CustomerInput
                          onChange={handleChange}
                          name="branch"
                          placeHolder="ENTER BRANCH"
                          inputStyles={{ padding: "12px" }}
                          value={data?.branch || ""}
                        />
                      </div>
                      <div className="col-span-12 md:col-span-6 lg:col-span-6 ">
                        <label
                          for="bank"
                          className="block text-md font-medium leading-6 text-gray-900"
                        >
                          Bank <span className="text-red-600">*</span>
                        </label>
                        <CustomerInput
                          onChange={handleChange}
                          name="bank"
                          placeHolder="ENTER BANK"
                          inputStyles={{ padding: "12px" }}
                          value={data?.bank || ""}
                        />
                      </div>
                    </div>
                    <div style={{ marginTop: "10px", marginBottom: "5px" }}>
                      <span
                        style={{
                          fontSize: "15px",
                          fontWeight: "400",
                          fontStyle: "italic",
                          color: validationResponse?.color,
                        }}
                      >
                        {validationResponse?.message || ""}
                        {validationResponse?.status || ""}
                      </span>
                    </div>
                    <div className="col-span-12 md:col-span-7 lg:col-span-7">
                      <div className="relative text-center">
                        {bankDetailsVerified === true ? (
                          <>
                            <button
                              className="vtpRm-action-button"
                              onClick={handleSubmit}
                            >
                              Submit
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              className="vtpRm-action-button"
                              onClick={VerifyBankDetails}
                            >
                              Validate
                            </button>
                          </>
                        )}
                        {/* <button onClick={handleSubmit} className="vtpRm-action-button">
                                                    {details?.result.gstin === '' || details?.result.gstin === undefined || details?.result.gstin === null ? 'Verify & Proceed' : 'Re-Verify & Proceed'}
                                                </button> */}
                        {details?.result.lastCompletedStep >= 5 ? (
                          <>
                            <span
                              className="skip-btn hover:cursor-pointer py-4 px-4"
                              onClick={() => {
                                if (data?.programId === 34) {
                                  navigate("/Customer/EmailServerDetail");
                                } else if (
                                  data?.programId === 32 ||
                                  data?.programId === 33
                                ) {
                                  navigate("/Customer/Step6");
                                } else {
                                  navigate("/Customer/Step7");
                                }
                              }}
                            >
                              Skip this step
                            </span>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
            </div>
          </div>
        </LogoDiv>
      </body>
    </>
  );
}
